export const CARLYLE_COMPANIES = [
  {
    id: "delhivery",
    name: "Delhivery",
    sector: "Logistics Technology",
    headcount: 65000,
    asbc_gap: 1850000000,
    labour_cost: 7200000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/delhivery-carlyle-2026",
    signal: "red",
    urgency_reason: "Last-mile workforce at critical automation inflection",
    functions: ["Last-Mile Delivery", "Hub Operations", "Technology", "Commercial", "Supply Chain Design", "Finance", "HR & People"],
    competitors: [
      { name: "Delhivery", score: 38, isTarget: true },
      { name: "Ecom Express", score: 52 },
      { name: "XpressBees", score: 58 },
      { name: "BlueDart", score: 62 },
      { name: "Amazon Logistics India", score: 78 },
    ],
    velocity_headline: "Amazon logistics restructuring 2\u00d7 faster",
    leadership_scores: [6, 5, 7, 6, 4, 6, 5],
    readiness_score: 74,
    readiness_drivers: [
      "65,000 workforce — massive scale transformation opportunity",
      "Last-mile delivery at critical AI/robotics inflection point",
      "Hub operations high BOT potential largely untapped",
    ],
  },
  {
    id: "hexaware",
    name: "Hexaware Technologies",
    sector: "IT Services",
    headcount: 32000,
    asbc_gap: 920000000,
    labour_cost: 3800000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/hexaware-carlyle-2026",
    signal: "red",
    urgency_reason: "AI disrupting delivery model — restructure now",
    functions: ["Delivery & Engineering", "Cloud & Infrastructure", "Digital & Analytics", "BPS Operations", "Finance", "HR & People"],
    competitors: [
      { name: "Hexaware Technologies", score: 42, isTarget: true },
      { name: "Mphasis", score: 68 },
      { name: "Persistent Systems", score: 72 },
      { name: "LTIMindtree", score: 64 },
      { name: "Coforge", score: 58 },
    ],
    velocity_headline: "AI disrupting IT services delivery at 1.7\u00d7 pace",
    leadership_scores: [7, 6, 6, 6, 5, 7, 6],
    readiness_score: 68,
    readiness_drivers: [
      "GenAI directly replacing code-and-test delivery tasks",
      "BPS operations at highest near-term automation risk",
      "32,000 workforce presents significant restructuring scale",
    ],
  },
  {
    id: "sbi-life",
    name: "SBI Life Insurance",
    sector: "Insurance",
    headcount: 18000,
    asbc_gap: 540000000,
    labour_cost: 2200000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/sbi-life-carlyle-2026",
    signal: "amber",
    urgency_reason: "Agency force transformation lagging InsurTech peers",
    functions: ["Agency & Distribution", "Underwriting", "Claims Processing", "Technology", "Finance", "HR & People"],
    competitors: [
      { name: "SBI Life Insurance", score: 36, isTarget: true },
      { name: "HDFC Life", score: 58 },
      { name: "ICICI Prudential", score: 54 },
      { name: "Max Life", score: 48 },
      { name: "PolicyBazaar", score: 82 },
    ],
    velocity_headline: "InsurTech peers restructuring agency force 2.3\u00d7 faster",
    leadership_scores: [6, 7, 4, 4, 6, 6, 6],
    readiness_score: 62,
    readiness_drivers: [
      "Agency distribution force at digitisation inflection",
      "Claims processing highly automatable but untouched",
      "PolicyBazaar benchmark shows sector direction clearly",
    ],
  },
  {
    id: "go-digit",
    name: "Go Digit Insurance",
    sector: "InsurTech",
    headcount: 4500,
    asbc_gap: 180000000,
    labour_cost: 720000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/godigit-carlyle-2026",
    signal: "amber",
    urgency_reason: "Tech-forward but ops workforce needs redesign",
    functions: ["Claims & Operations", "Technology", "Product", "Distribution", "Finance", "HR & People"],
    competitors: [
      { name: "Go Digit Insurance", score: 52, isTarget: true },
      { name: "Acko", score: 68 },
      { name: "PolicyBazaar", score: 82 },
      { name: "Turtlemint", score: 58 },
      { name: "RenewBuy", score: 48 },
    ],
    velocity_headline: "Tech-forward but ops workforce design lagging product pace",
    leadership_scores: [7, 5, 7, 7, 5, 6, 6],
    readiness_score: 48,
    readiness_drivers: [
      "Claims and operations function needs workforce redesign",
      "Strong tech DNA but operational bloat growing",
      "Distribution model restructuring opportunity identified",
    ],
  },
  {
    id: "ptc-india",
    name: "PTC India",
    sector: "Power & Energy",
    headcount: 8500,
    asbc_gap: 280000000,
    labour_cost: 1100000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/ptc-india-carlyle-2026",
    signal: "red",
    urgency_reason: "Energy sector AI transformation accelerating",
    functions: ["Power Trading", "Project Consulting", "Technology", "Renewable Energy", "Finance", "HR & People"],
    competitors: [
      { name: "PTC India", score: 30, isTarget: true },
      { name: "NTPC", score: 48 },
      { name: "Tata Power", score: 62 },
      { name: "Adani Green", score: 72 },
      { name: "ReNew Energy", score: 68 },
    ],
    velocity_headline: "Energy sector AI transformation accelerating at 2.4\u00d7",
    leadership_scores: [5, 7, 3, 3, 5, 5, 5],
    readiness_score: 72,
    readiness_drivers: [
      "Power trading function at highest near-term automation risk",
      "Renewable energy transition creating workforce restructuring window",
      "Digital & AI capability at 3/10 is critically low for sector pace",
    ],
  },
];
